/**
 * Next value for one of the outline drawer's two section lists (the expanded
 * list and the collapsed list).
 *
 * The contract that matters is the identity one: when the section is already
 * in the state being asked for, the **same array** comes back, not an equal
 * copy.
 *
 * React compares state by identity, and `ensureSectionOpenForDrop` calls this
 * for every `dragover` event while a slide is being dragged — many times a
 * second, almost always asking for a section that is already open. Returning a
 * fresh array each time (which `filter()` and `Array.from()` both do, even
 * when they change nothing) re-rendered the drawer continuously and, worse,
 * changed the identity of both lists. Those lists are dependencies of the
 * effect that keeps the current slide in view, so every dragover restarted a
 * smooth `scrollIntoView` on the *selected* slide: the outline lurched back
 * down while the author was dragging a slide up, and fought the drag's own
 * auto-scroll the whole way.
 */
export const withSectionMembership = (list, sectionId, shouldContain) => {
  if (!Array.isArray(list)) return [];
  if (list.includes(sectionId) === shouldContain) return list;
  return shouldContain
    ? [...list, sectionId]
    : list.filter((id) => id !== sectionId);
};

export default withSectionMembership;
